import { shouldShowError } from '@organisms/HomeTab/homeUtils';
import { NavigationProp } from '@react-navigation/native';
import { BOTTONSHEET_PHONE_CONTENT, BOTTONSHEET_PHONE_ENROLLMENT, COMMON_CONSTANTS } from '@root/constants';
import { logResetPinLater, logXClick } from '@screens/GGAddBankScreen/analyticsBankScreen';
import AmplitudeHelper from '@utils/analytics';
import { AMPLITUDE_CONSTANTS, AMPLITUDE_EVENT_SOURCES } from '@utils/analytics/constants';
import { goBackToHome, returnBottomSheetContent } from '@utils/utils';
import { Linking } from 'react-native';

interface InfoModal {
  errorCode?: string;
  visible: boolean;
  data?: any;
}

interface BottomSheetHandlersReturn {
  onPressPrimary: () => void;
  onPressSecondaryHandler: () => void;
  onCloseHandler: () => void;
}

export function bottomSheetHandlers(
  setInfoModal: React.Dispatch<React.SetStateAction<InfoModal>>,
  infoModal: InfoModal,
  navigation: NavigationProp<any>,
  addPhoneNumber: (vars: any) => void,
  variables: any,
): BottomSheetHandlersReturn {
  const onPressPrimary = () => {
    setInfoModal(prev => ({ ...prev, visible: false }));

    if (infoModal.errorCode === 'THREE_RETRY_VERIFICATION') {
      addPhoneNumber({ ...variables, securityPin: null });
      logResetPinLater();
    }
  };

  const resetPinHandler = () => Linking.openURL(COMMON_CONSTANTS.support);

  const onPressSecondaryHandler = () => {
    setInfoModal(prev => ({ ...prev, visible: false }));

    if (infoModal.errorCode === 'THREE_RETRY_VERIFICATION') {
      goBackToHome(navigation);
      resetPinHandler();
      const e = AMPLITUDE_CONSTANTS.securityPin.reset_pin_clicked;
      AmplitudeHelper.logEvent(e.name, {
        [e.attributes.source]: 'pin_failed_modal_phonenumber',
      });
    }
  };

  const onCloseHandler = () => {
    setInfoModal(prev => ({ ...prev, visible: false }));

    if (infoModal.errorCode === 'THREE_RETRY_VERIFICATION') {
      addPhoneNumber({ ...variables, securityPin: null });
      logXClick();
    }
  };

  return { onPressPrimary, onPressSecondaryHandler, onCloseHandler };
}

export function errorHandler(
  isError: boolean,
  error: string[],
  navigation: NavigationProp<any>,
  setInfoModal: React.Dispatch<React.SetStateAction<InfoModal>>,
  toast: any,
  t: (key: string) => string,
  setInitialData: () => void,
): void {
  if (isError && error) {
    navigation.goBack();

    if (error[0] === 'GG-PHONE-02') {
      const e = AMPLITUDE_CONSTANTS.PhoneEnroll.save_phonenumber_error;
      AmplitudeHelper.logEvent(e.name, {
        [e.attributes.error_message]: 'number_duplicated',
      });

      return setInfoModal(prev => ({
        ...prev,
        data: returnBottomSheetContent(
          BOTTONSHEET_PHONE_ENROLLMENT.DUPLICATE_ENTRY,
          BOTTONSHEET_PHONE_CONTENT[BOTTONSHEET_PHONE_ENROLLMENT.DUPLICATE_ENTRY],
        ),
        errorCode: BOTTONSHEET_PHONE_ENROLLMENT.DUPLICATE_ENTRY,
        visible: true,
      }));
    }

    if (error[0] === 'GG-PHONE-03') {
      const e = AMPLITUDE_CONSTANTS.PhoneEnroll.save_phonenumber_error;
      AmplitudeHelper.logEvent(e.name, {
        [e.attributes.source]: AMPLITUDE_EVENT_SOURCES.add_phonenumber_page,
        [e.attributes.error_message]: 'max_reached',
      });

      return setInfoModal(prev => ({
        ...prev,
        data: returnBottomSheetContent(
          BOTTONSHEET_PHONE_ENROLLMENT.MAX_LIMIT,
          BOTTONSHEET_PHONE_CONTENT[BOTTONSHEET_PHONE_ENROLLMENT.MAX_LIMIT],
        ),
        errorCode: BOTTONSHEET_PHONE_ENROLLMENT.MAX_LIMIT,
        visible: true,
      }));
    }

    return shouldShowError(isError, error, toast, t, navigation, setInitialData);
  }
}
